<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/h0PT2z/cover.jpeg?1684514597517" alt="This image is the cover for the book Story of Fantasies, Volume 1"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Story of Fantasies, Volume 1
      </h1>
      <p class="bookDescription body article font2">
        <p>The meeting of the male and female masters in the dark is the arrangement of fate. The female masters have dual characters. On the one hand, they are indecisive and weak women. On the other hand, they are cold and powerful. In this paper, the female masters and slaves use the male masters to be together with him to really fall in love with the male masters as the main line, in which the former life of the male and female masters is the auxiliary line, telling another love story.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zhenyinfang, Lemon Novel
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Funstory
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01dd0e35